import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {AppBaseComponent} from '../../../commons/AppBaseComponent';
import {MapService} from '../../../commons/map.service';
import {AppService} from '../../../commons/app.service';
import {MatDialog, MatSnackBar} from '@angular/material';
import {Router} from '@angular/router';
import {FourDService} from '4d-mapper';
import {MapComponent} from '../map.component';
import { XsApplicationEventsService } from '../../../xs/services/events/application-events.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-credit-notes',
  templateUrl: './credit-notes.component.html',
  styleUrls: ['./credit-notes.component.scss']
})
export class CreditNotesComponent extends AppBaseComponent implements OnInit, OnDestroy {

  constructor(public fourD: FourDService, public service: AppService, public router: Router,
              public snackBar: MatSnackBar, public dialog: MatDialog, public mapService: MapService, public mapComp: MapComponent, applicationEvents:XsApplicationEventsService) {
    super(service, router, snackBar, dialog, applicationEvents);
  }

  openCreditNotes() {
   
    let creditFound = false;
    let companyDetails = '';
    let companyNames = '';
    [this.mapService.scene].forEach(scene => {
      if (scene['creditBy']) {
        creditFound = true;
        companyNames += ', ' + scene['creditBy'];
      }
      scene._cachedTransforms.forEach(ct => {
        if (ct['creditBy']) {
          creditFound = true;
          companyNames += ', ' + ct['creditBy'];
        }
      })
    })
    if(this.fourD.domainConfig){
      if(this.fourD.domainConfig['credits'])
        companyDetails += this.fourD.domainConfig['credits']
      else if (creditFound) {
        companyDetails += 'Data is provided by ' + companyNames.substr(1, companyNames.length) + '\n\n';
      }
      if(this.fourD.domainConfig['credits_info'])
        companyDetails += '\r\n' + this.fourD.domainConfig['credits_info']
    }
    else
   
      companyDetails += '@Copyright MapSender Pty Ltd. 2022 ' + '\n\n' + 'Front-end visualization uses CesiumJS WEBGL and requires WEBGL compatible browsers such as Chrome or Firefox.';
      
    
    this.openDialog('', companyDetails).subscribe();

  }

}
